import { z } from "zod";

export const sendingViews = ["overview", "email", "push", "sms"] as const;
export const sendingSearch = z.object({
  // Stale `?view=activity` deep links fall back to overview instead of erroring.
  view: z.enum(sendingViews).default("overview").catch("overview"),
  env: z.string().max(255).optional(),
});
export type SendingSearch = z.infer<typeof sendingSearch>;
export type SendingTarget = { project: string; environment: string };
